import cns from 'classnames'

import { Text } from 'shared/ui/common/Text'
import { RoundCTAButton } from 'shared/ui/controls/RoundCTAButton'

import { PoolAsset } from 'modules/pools/constants/poolAssets'
import s from './DoubleBubbleCTA.module.scss'

type Props = {
  asset: PoolAsset
  bridgeLink: string
  oneInchLink: string
  className?: string
}

export function DoubleBubbleCTA({
  asset,
  bridgeLink,
  oneInchLink,
  className,
}: Props) {
  return (
    <div className={cns(s.wrap, className)}>
      <Text
        size={12}
        weight={500}
        color="secondary"
        isCentered
        isUppercased
        className={s.title}
      >
        You don’t have enough of {asset} on polygon
      </Text>

      <RoundCTAButton
        href={bridgeLink}
        isExternal
        size={180}
        borderOffset={20}
        className={cns(s.button, s.buttonOne)}
      >
        <Text size={12} weight={500} isUppercased>
          Bridge from
          <br />
          another chain
        </Text>
      </RoundCTAButton>

      <RoundCTAButton
        href={oneInchLink}
        isExternal
        size={168}
        borderOffset={20}
        className={cns(s.button, s.buttonTwo)}
        classNameBg={s.buttonTwoBg}
      >
        <Text size={12} weight={500} isUppercased>
          Get {asset}
          <br />
          on 1inch
        </Text>
      </RoundCTAButton>
    </div>
  )
}
